import { render, staticRenderFns } from "./Statistic_Controller.vue?vue&type=template&id=3cd40a71&scoped=true&"
import script from "./Statistic_Controller.vue?vue&type=script&lang=js&"
export * from "./Statistic_Controller.vue?vue&type=script&lang=js&"
import style0 from "./Statistic_Controller.vue?vue&type=style&index=0&id=3cd40a71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd40a71",
  null
  
)

export default component.exports